export const mutation_add_import_mapping = `
mutation addLog($tenantId: String, $aziendaId: Int, $type: String, $mappedValue: String!, $value: String!) {
    insert_import_mapping_one(object: {TenantId: $tenantId, AziendaId: $aziendaId, Type: $type, MappedValue: $mappedValue, Value: $value}) {
        Id
        TenantId
        AziendaId
        Type
        MappedValue
        Value
        CreatedOn
        ModifiedOn
        CreatedBy
        ModifiedBy
    }
}`;
export const mutation_update_import_mapping = `
mutation updateImportMapping($tenantId: String!, $aziendaId: Int, $type: String, $mappedValue: String!, $value: String!) {
    update_import_mapping(where: {TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}, Type: {_eq: $type}, MappedValue: {_eq: $mappedValue}}, _set: {Value: $value, ModifiedOn: "now()"}) {
        returning {
        Id
        TenantId
        AziendaId
        Type
        MappedValue
        Value
        CreatedOn
        ModifiedOn
        CreatedBy
        ModifiedBy
        }
    }
}`;
